import React from "react";
import NewSection from "./NewSection";
import BestSeller from "./BestSeller";

export default function Main() {
  return (
    <>
      <NewSection />
      <BestSeller />
    </>
  );
}
